import _ from 'lodash';
import allModelData from '@/admin_models/all';

export const modelData = _.merge({}, allModelData, {
  'User': {
    label: 'wechat_mp_openid'
  },
})

export const getLabel = ({ item }) => {
  if (item.cn) {
    const label = modelData[item.cn]['label']

    if (typeof label === 'function') {
      return label(item)
    } else {
      return item[label]
    }
  }
}
